var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusThick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33 33"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 89",
    d: "M16.528 32.5a2.5 2.5 0 01-2.5-2.492l-.025-11-11 .025h-.006a2.5 2.5 0 01-.006-5l11-.025-.026-11a2.5 2.5 0 012.491-2.5h.006A2.505 2.505 0 0118.962 3l.026 11 11-.025h.006a2.5 2.5 0 11.006 5L19 19l.025 11a2.507 2.507 0 01-2.5 2.508z",
    fill: "currentColor",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10
  })));
}
export default SvgPlusThick;